/* 法语 */
export default {
  local: {
    reacquire_password: "Ré-obtenez après ",

    account_login: "Compte",
    mobile_number_login: "Mobile",
    authentication_code_login: "Code de vérificatio",
    account_name_email: "Nom du compte/email",
    forgot_password: "Mot de passe oublié ?",
    please_enter_the_account_number: "Entrez votre numéro de compte",
    please_enter_the_password: "Entrez le mot de passe",
    account_not_registered: "Compte non enregistré",
    incorrect_password: "Mot de passe incorrect",
    not_joined_the_class:
      "Non-inscrit à une classe / Classe inscrit pas de diffusion",
    password_lock_time:
      "Trop erreur du mot de passe, réessayez dans 10 minutes",
    password_lock: "Compte actuel bloqué, réessayez plus tard",
    phone_number: "N° Portable",
    please_enter_your_mobile_number: "Entrez le numéro de portable",
    mobile_number_format_error: "Mauvais format de numéro de portable",
    mobile_number_is_not_registered: "Numéro de portable non enregistré",
    verification_code: "Code SMS",
    get_verification_code: "Obtention",
    please_enter_the_verification_code: "Entrez le code de vérification",
    code_failure_or_error: "Code de vérification invalide ou incorrect",
    code_too_many_times:
      "Les récupérations du code de vérification ont dépassé la limite, réessayez après 24 heures",
    go_back: "Retour",
    reset_your_password: "Réinitialisez MDP",
    new_password: "Nouveau MDP",
    save_changes: "Confirmation",
    reset_the_password_by_using_the_email_address: "Réinitialisez par e-mail",
    please_enter_the_password_address: "Définissez votre mot de passe",
    your_password_has_been_reset: "Réinitialisation du mot de passe réussie",
    password_rule: "Combinaison de 6-18 chiffres, lettres et symboles",
    emai: "E-mail",
    reset_the_password_by_using_the_mobile_number:
      "Réinitialisez par le portable",
    please_enter_the_email_address: "Entrez votre adresse e-mail",
    unregistered_mailbox: "E-mail non enregistré",

    student: "Élève",
    teacher: "Enseignants",
    assistant: "Aide-enseignant",
    sign_in: "Entrez",
    identity_to_sign_in: "Sélectionnez le statut de connexion",
    change_password: "Modifiez MDP",
    switch_identity: "Changez de statut",
    sign_out: "Déconnectez-vous",
    class_on_phones: "Cours sur portable",
    mobile_terminal_by_scanning:
      "Accès du terminal mobile par le code QR ou le\n" + "lien du portable",
    copy_link: "Copiez le lien",
    shut_off: "Fermez",
    account: "Connexion du compte",
    old_password: "Mot de passe original",
    re_enter_password: "Entrez à nouveau",
    please_enter_the_old_password: "Entrez le mot de passe original",
    please_enter_the_new_password: "Entrez le nouveau mot de passe",
    please_re_enter_the_new_password: "Ré-saisissez le nouveau mot de passe",
    password_modified_successfully: "Modification réussie du mot de passe",
    old_password_error: "Erreur du mot de passe original",

    user_name: `Nom d'utilisateur`,
    password: "Mot de passe",
    login: "Accéder",
    the_user_name_or_password_is_incorrect:
      "Le nom d’usager ou le mot de passe incorrect",
    note: "Rappel",
    log_out: "Quitter",
    certificate_application: "Demander un certficat",
    more: "Plus",
    close: "Fermer",
    learn_courses: "Étudier les cours",
    class_schedule: "Calendrier",
    data_download: "Télécharger",
    selective_courses: "Cours d’option",
    receive_notices: "Recevoir des notifications",
    to_do_list: "Tâche à faire",
    important_notices: "Notifications",
    write_summary: "Rédiger un résumé",
    project_comment: "Évaluation de projet",
    feedback: "Feed-back",
    my_summary: "Mon résumé",
    evaluate_service_quality: "Évaluer la qualité du service",
    completed: "Achevé",
    unavailable: "Non disponible",
    uncompleted: "Inachevé",
    coming_soon: "En attente",
    application_successful: "Demande réussie!",
    the_certificate_will_be_sent_to_your_mail: `Le certificat sera envoyé à votre l'adresse email le jour d’achèvement de vos cours. Si vous avez des questions, veuillez contacter le coordinateur de votre classe.`,
    ok: "Valider",
    please_complete_your_to_do_list:
      "Veuiller demander le certificat après terminer les choses àfaire!",
    to_complete: "Valider",
    would_you_like_to_check_your_reports:
      "Veuillez vérifier vos rapports avant la demande du certificat?",
    no_modification_upon_submission: "Impossible de modifier une fois soumis!",
    go_and_check: "Aller vérifier",
    submit: "Soumettre",
    application_submitted: "Application soumise",
    my_class: "Ma classe",
    course_calendar: "Calendrier des cours",
    back_to_today: "Aujourd’hui",
    today: "Aujourd’hui",
    course_replay: "Relecture des cours",
    no_courses: "Pas de cours",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    instructor: "Instructeur",
    comment: "Commentaire",
    replay: "Relecture",
    join: "Entrer",
    class_begins_at: "La classe commence à",
    lasting_for: "Durée",
    all: "Toutes",
    video: "Vidéos",
    image: "Photo",
    no_data: "Non disponible",
    china_today_serial_courses: "La Chine au présent",
    language: "Langue",
    features: "Sujets",
    finance: "Chine financière",
    trade: "Commerce de la Chine",
    commerce: "Affaires de la Chine",
    planning: "Urbanisme chinois",
    infrastructure: "Infrastructures de la Chine",
    development_cooperation:
      "Coopération internationale de développement de la Chine",
    important_notices_title: "Notifications",
    all_notes: "Toutes",
    course: "Cours",
    event: "Evénement",
    class: "Classe",
    task: "Tâche",
    no_notes: "Non disponible",
    content: "Contenu",
    turn_to_page: "Tourner à la page XXX",
    please_complete_the_report: "Veuillez terminer le rapport XXX.",
    please_complete_the_course_comment:
      "Veuillez terminer le commentaire sur XXX.",
    fill_in: "Remplir",
    no_matter: "Non disponible",
    list: "Liste",
    original: "Original",
    speed: "Fois",
    scored: "XXX Point",
    fill_in_at_least_XXX_characters: "Remplir au moins XXX caractères.",
    words_already_entered: "XXX mots déjà saisis.",
    submission_successful: "Soumission réussie",
    up_to_10000_words: "10,000 mots au maximum!",
    up_to_20000_words: "20,000 mots au maximum!",
    up_to_50000_words: "50,000 mots au maximum!",
    course_comment: "Commentaire des cours",
    to_submit: "Soumettre",
    to_close: "Fermer",
    instructions: "Remarques",
    evaluation_type: `type d'évaluation`,
    very_good: "très bon",
    good: "bon",
    bad: "mal",
    total_points: "Nombre total de points",
    trainers_level: "Niveau des formateurs",
    teaching_material_quality: "Qualité des matériels didactiques",
    translation_level: `Niveau d'interprètation`,
    interactive_communication_situation: `Situation d'interaction`,
    multimedia_teaching_quality: `Qualité de l'enseignement multimédia`,
    course_degree_of_difficulty: `Degré de difficulté des cours`,
    correlation_between_course_and_the_program_theme: `Corrélation entre les cours et le thème du programme`,
    comment_table_score_hint: `Remarque: 2 points pour "très bon" , 1 point pour "bon", 0 points pour "mal". Chaque cours est sur 14 points.`,
    participants_feedback_form: "Formulaire de feed-back pour les participants",
    participants_feedback_form_state:
      "Félicitation à vous sur la réussite de votre formation.Veuillez laisser vos commentaires sur le séminaire.",
    participants_feedback_form_instructions:
      "Le formulaire de feed-back que vous remplissez reflète principalement vos opinions et suggestions sur l'ensemble du projet de formation.<br/>" +
      "En plus de vos commentaires sur ce projet, nous aimerions également connaître vos besoins et suggestions pour de futurs projets, notamment :<br/>" +
      "1.Quels sujets de cours souhaitez-vous que nous proposions ?<br/>" +
      "2.Quelles villes chinoises souhaitez-vous visiter ?<br/>" +
      "3.Quels types d’entreprises chinoises souhaitez-vous visiter ?<br/>" +
      "4.Avez-vous des projets de coopération économique, commerciale, éducative ou autre en Chine ou à Shanghai ?<br/>" +
      "5.Avez-vous des besoins spécifiques en matière de coopération commerciale ?",
    final_report: "Rapport Final",
    final_report_state:
      "Félicitation à vous sur la réussite de votre formation.Veuillez laisser vos rapports sur le séminaire.",
    final_report_instructions:
      "Le rapport doit inclure les quatre aspects suivants:<br/>" +
      "（1）Présenter votre profil et les raisons de votre participation à ce séminaire.<br/>" +
      "（2）Faire une conclusion pour ce séminaire sur les différences entre votre pays et la Chine dans des domaines connexes.<br/>" +
      "（3）Partager les intérêts et acquis sur ce séminaire.<br/>" +
      "（4）Exprimer vos attentes et suggestions.<br/>" +
      "(Aucune restriction de mot, mais vous devez le terminer vous-même.)",
    trainee_evaluation_form_of_foreign_assistance_training_program: `Formulaire d'évaluation du programme de formation à l'assistance étrangère`,
    trainee_evaluation_form_of_foreign_assistance_training_program_state: `Merci de participer à ce programme de séminaire/formation. Afin de nous permettre d'améliorer notre travail, s'il vous plaît faire une évaluation sur cette formation, et donner votre point de vue par rapport aux question suivantes. Nous vous remercions de votre coopération.`,
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions: `Il s'agit d'une forme d'évaluation complète du séminaire, en espérant que cette évaluation pourra refléter fidèlement les effets réelles des programmes mis en œuvre par notre base de formation. Vos opinions, évaluations et notes sont importantes pour la reconnaissance et l'amélioration de la base de formation. La note maximale pour chaque élément est de <span>5</span> points et la note totale est de <span>100</span> points.`,
    foreign_aid_training_service_quality_survey:
      "Enquête de l'école de commerce de Shanghai sur la qualité des programmes de formation des agents d'aide étrangère 		",
    foreign_aid_training_service_quality_survey_state:
      "Merci d'avoir assisté à ce programme de formation.  Pour nous aider à améliorer la qualité globale de nos programmes de formation d'agents d'aide étrangère, veuillez répondre à ce sondage d'évaluation du service avec vos commentaires et vos évaluations, ce qui fournira un guide important pour nous permettre d'identifier les domaines à améliorer. ",
    foreign_aid_training_service_quality_survey_instructions:
      "Veuillez évaluer chaque service en cochant d'un (√) la case correspondant au score approprié.  Le score indique le niveau de votre satisfaction à l'égard du service; 5 = très satisfait, 4 = satisfait, 3 = neutre, 2 = insatisfait, et 1 = très insatisfait.  Si vous avez d'autres commentaires à proposer, écrivez-les dans la section Commentaires. ",
    points: "Points",
    training: "Formation",
    course_arrangement: "Arrangement des cours",
    suitability_of_course_quantity: "Quantité des cours",
    quality_of_teaching_materials_or_handouts:
      "Qualité des matériels didactiques ou des documents",
    correlation_between_study_tours_and_the_program_theme: `Corrélation entre les voyages d'études et le thème du programme  `,
    arrangement_for_study_tours_or_internships: `Arrangement des voyages d'études ou des stages`,
    classrooms_and_teaching_equipments: `Salles de classe et matériels pédagogiques`,
    management: "Gestion",
    accommodation:
      "Conditions du logement (0 pour la chambre individuelle non-privée)",
    airport_transfer_and_catering_services_arrangement: `Arrangement de transfert de l'aéroport  et de restauration`,
    opening_and_closing_ceremonies_arrangement: `Arrangement des cérémonies d'ouverte et de cloture`,
    cultural_experience_and_extracurricular_activities_arrangement: `Arrangement des expériences culturelles et des activités  parascolaires`,
    attitude_of_the_Chinese_staff: `Attitude du personnel chinois`,
    organizational_skills_of_the_Chinese_staff: `Capacité d'organisation du personnel chinois`,
    english_communication_skills_of_the_Chinese_staff: `Aptitudes de communication en français du personnel chinois`,
    synthesis: "Synthèse",
    program_duration: "Durée du programme",
    help_of_the_program_on_your_future_work:
      "Aide de ce programme sur votre travail futur",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "Rôle de ce programme dans la promotion de la coopération entre la Chine et votre pays dans les domaines concernés",
    your_overall_evaluation_of_the_program:
      "Votre évaluation générale sur ce programme",
    your_suggestion_and_comment: "Votre suggestion et commentaire",
    your_impression_of_China: "Votre impression de la Chine",
    report: "Rapport",
    error_request: "Demande échouée.",
    download_live_streaming_tool: "Télécharger l’outil de l’émission directe",
    windows_7_and_above: "Windows 7 ou version supérieure",
    no_replay: "Non disponible",
    look_over: "Regarder",
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
    please_enter_a_user_name: "Saisir le nom d’usager",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "Votre accès a dépassé le temps. Veuillez cliquer sur le bouton pour accéder à nouveau.",
    please_complete_all_comments_before_submission:
      "Terminer tous les commentaires avant la soumission!",
    please_fill_in: "Saisir.",
    it_cannot_be_empty: "Ceci ne peut pas être vide.",
    comment_successful: "Commentaire réussi!",
    if_there_is_no_prompt_on_the_browser_please_try_again: `S'il n'y a pas de réponse, veuillez réessayer.`,
    click_here_to_try_again: "Cliquer ici pour réessayer.",
    if_you_have_not_installed_the_live_streaming_tool:
      "Si vous n’avez pas installé l’outil de l’émission directe, veuillez télécharger et réessayer.",
    class_information: "Information de classe",
    reload: "Télécharger à nouveau",
    you_do_not_have_permission_to_access_the_current_page:
      "Vous n’avez pas accès à la page actuelle",
    return_to_home_page: "Page d’accueil",
    total_points_project_comment: "Nombre total de points",
    record_course_over_tip_msg:
      "Le cours est fini. Veuillez joindre la class interactive immediatement",
    page_live_entry_tips:
      "Si vous ne pouvez pas accéder à Classin, visitez la page Web pour étudier.<br>(Vous ne pouvez pas communiquer avec les professeurs par la page de réseau)",
    page_live_entry_txt: "Ouvrir un nouveau lien",
    select_class: "Classe",
    start: "Etudier",
    download: "Télécharger",
    class_on_phones: "Cours sur portable",
    class_on_phones_tip:
      "Accès du terminal mobile par le code QR ou le lien du portable",
    copy_successfully: "Copiez avec succès"
  }
};



// WEBPACK FOOTER //
// ./src/lang/fr/index.js